module.exports = __webpack_public_path__ + "img/js.de79c8f1.svg";